module.exports = __webpack_public_path__ + "static/media/cancelar-tarjeta.e3371f1d.svg";